import { MEDIA_QUERIES } from '@student-coin/coinpaper-components';
import tw, { css, styled } from 'twin.macro';

export const imageContainerStyle = css`
  padding: 1rem 0;
  margin: auto;

  @media ${MEDIA_QUERIES.tablet} {
    padding: 1.5rem 0;
  }
`;

export const captionStyle = css`
  ${tw`font-inter`};
  font-style: normal;
  font-weight: normal;
  font-size: 0.75rem;
  line-height: 0.813rem;
  color: ${({ theme }) => theme.colors.label};
  padding-top: 0.25rem;

  @media ${MEDIA_QUERIES.tablet} {
    font-size: 0.75rem;
    line-height: 1rem;
    padding-top: 0.5rem;
  }
`;

export const Container = styled.div`
  ${tw`grid-cols-12`}
  width: 100%;
  ${imageContainerStyle}
`;

export const Caption = styled.figcaption<{ reduceWidth?: boolean }>`
  margin: auto;
  width: ${({ reduceWidth }) => (reduceWidth ? '30%' : '100%')};
  ${captionStyle};
  text-align: right;
`;

export const ImageBox = styled.div`
  img {
    cursor: zoom-in;
  }
  span {
    position: static !important;
  }
`;
